import { cookie, post, put } from "./base";
const base = "/subtitle";
export const createSubTitle = async (data) => {
  return post(`${base}/generate_subtitle/`, data);
};

export const uploadSubtitleVideo = async (userId, data) => {
  try {
    const formData = new FormData();
    formData.append("file", data);
    formData.append("user_id", userId);
    return post(
      `${process.env.REACT_APP_SERVER_API_URL}/subtitle/upload_subtitle_video/`,
      formData,
      {
        thirdParty: true,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": cookie("csrftoken"),
        },
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export const updateSubTitle = async (data) => {
  return put(`${base}/update_subtitle/`, data);
};
export const approveVideoSubTitle = async (data) => {
  return post(`${base}/approve_transcript/`, data);
};
